function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 0.75,
  width: 19.5,
  height: 22.5,
  rx: 1.5,
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 6.25h3M1.5 12h3m-3 5.75h3",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.5,
  cy: 8.62,
  rx: 2.25,
  ry: 2.63,
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 11.25v6m6-6v6M15 6v3.75a1.5 1.5 0 001.5 1.5 1.5 1.5 0 001.5-1.5V6",
  fill: "none"
});

function SvgRestaurantMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgRestaurantMenu;